import { computed, inject, onMounted } from "vue";

import { useCaseStore } from "@/stores/case-store";
import { useBrandStore } from "@/stores/brand-store";
import { useCaseFileStore } from "@/stores/case-file-store";

import type { InjectionKey, Ref } from "vue";

export const CASE_ROUTE_PARAMS_KEY = Symbol() as InjectionKey<Ref<InjectedCaseRouteParams>>;

const ERROR = new Error("This hook should only be used in the Case Routes");

export function useCaseRouteParams() {
  const caseStore = useCaseStore();
  const brandStore = useBrandStore();
  const caseFileStore = useCaseFileStore();

  const fallback = computed<InjectedCaseRouteParams>(() => {
    const selectedClient = brandStore.selectedClient;
    const selectedBrand = brandStore.selectedBrand;
    const selectedCaseName = caseStore.selectedCaseName;

    if (selectedClient == null || selectedBrand == null || selectedCaseName == null) {
      return {} as never;
    }

    return {
      ...brandStore.currentRoute.params,
      client: selectedClient,
      brand: selectedBrand,
      casename: selectedCaseName,
      casefile: caseFileStore.selectedCaseFile,
    };
  });

  onMounted(() => {
    if (fallback.value.client == null || fallback.value.brand == null || fallback.value.casename == null) throw ERROR;
  });

  return inject(CASE_ROUTE_PARAMS_KEY, fallback);
}

export type InjectedCaseRouteParams = CaseRouteParams & { client: string };

export interface CaseRouteParams {
  brand: string;
  casename: string;
  casefile?: string;
  annotation?: string;
  filepage?: string;
  snippet?: string;
  time?: string;
  startTime?: string;
  endTime?: string;
  fieldPath?: string;
}
